module.exports = __webpack_public_path__ + "images/instagram-icon---241820928fc03825399616f26e71bfb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/instagram-icon.png
// module id = 392
// module chunks = 0